/* eslint-disable  @typescript-eslint/no-explicit-any */

import { Okpd2Item, TreeItem, FlatTreeItem, FlatTreeDictionary, FormattedTreeItem, FormattedTreeDictionary } from "@/types/suppliers";

export function createTreeItem(key: string, parentKey: string, path: Array<string>, items: FormattedTreeDictionary, getByKey: Function): FormattedTreeItem | null {
    const info = getByKey(key);

    if (!info) {
        return null;
    }

    const children = info.child
        && info.child.length
        && info.child
            .map((childKey: string) => createTreeItem(childKey, key, [...path, key], items, getByKey))
            .filter((x: FormattedTreeItem | null) => x)
            .map((x: FormattedTreeItem) => x.key)
        || null;

    const item: FormattedTreeItem = {
        key,
        parentKey,
        path,
        children,
        name: info.name,
        expanded: false,
        count: null,
        hide: false,
    };

    items[key] = item;

    return item;
}

export function hasValue(value: any): boolean {
    if (value === null) return false;
    if (value === undefined) return false;
    if (value === '') return false;
    if (value === 0) return true;
    if (typeof value === 'object' && Array.isArray(value) && value.length <= 0) return false;

    if (value) return true;
    return false;
}

export function flatTree(v: Array<Okpd2Item>): FlatTreeDictionary {
    if (typeof v === 'object' && !Array.isArray(v)) return v;

    const flt = (array: Array<Okpd2Item>, kv: FlatTreeDictionary | undefined, prntKey: string | null | undefined, po: FlatTreeItem | undefined): FlatTreeDictionary => {
        if (!kv)
            kv = {} as FlatTreeDictionary;
        if (!array || array.length <= 0)
            return kv;

        array.forEach((a: Okpd2Item) => {
            if (!a) return;

            let key: string | undefined;
            if (hasValue(a.key))
                key = a.key;

            const { child } = a;
            const value = { name: a.name } as FlatTreeItem;

            if (kv)
                kv[key || ''] = value;

            value.parent = hasValue(prntKey) ? prntKey || '' : value.parent;
            if (!hasValue(value.parent)) {
                if (kv) {
                    if (!kv.root)
                        kv.root = [] as Array<string>;
                    kv.root.push(key || '');
                }
            }

            if (po) {
                if (!po.child) po.child = [];
                po.child.push(key || '');
            }

            if (child && child.length > 0) {
                flt(child, kv, key, value);
            }
        });

        return kv;
    };

    const obj = flt(v, undefined, undefined, undefined);
    return obj;
}

export function flatDict(v: Array<TreeItem>): FlatTreeDictionary {
    if (typeof v === 'object' && !Array.isArray(v)) return v;

    const kv = {} as FlatTreeDictionary;
    const array = v;
    if (!array || array.length <= 0) return kv;
    array.forEach((a: TreeItem) => {
        if (!a || a.key === a.parent) return;

        let key: string | undefined;
        if (hasValue(a.key))
            key = a.key;

        const value = (kv[key || ''] as FlatTreeItem) || (kv[key || ''] = ({} as FlatTreeItem));
        value.name = a.name;
        value.level = a.level;
        value.parent = a.parent;

        const pk = value.parent || '';
        if (!hasValue(pk)) {
            if (!kv.root)
                kv.root = [] as Array<string>;
            kv.root.push(key || '');
        } else {
            const po = (kv[pk] as FlatTreeItem) || (kv[pk] = ({} as FlatTreeItem));
            if (!po.child)
                po.child = [] as Array<string>;
            po.child.push(key || '');
        }
    });

    return kv;
}

export function formatOkpd2Tree(okpd2Items: FlatTreeDictionary | undefined): { items: FormattedTreeDictionary; rootKeys: Array<string> } | null {
    if (!okpd2Items) {
        return null;
    }

    const okpd2 = okpd2Items;

    const items = {} as FormattedTreeDictionary;
    const rootItems = [] as Array<FormattedTreeItem | null>;

    for (const key in okpd2) {
        if ((okpd2[key] as FlatTreeItem).parent && ((okpd2[key] as FlatTreeItem).parent || '').length === 1) {
            rootItems.push(createTreeItem(key, 'root', [], items, (k: string) => okpd2[k]));
        }
    }

    rootItems.push(createTreeItem('00.00.00.000', 'root', [], items, (key: string) => okpd2[key]));

    const rootKeys = rootItems.filter((x) => x).map((x) => (x as FormattedTreeItem).key);

    items.root = {
        key: 'root',
        children: rootKeys,
    };

    return { items, rootKeys };
}

export function formatTree(kladrItems: FlatTreeDictionary | undefined): { items: FormattedTreeDictionary; rootKeys: Array<string> } | null {
    if (!kladrItems) {
        return null;
    }

    const places = kladrItems;

    const items = {} as FormattedTreeDictionary;
    const rootItems = [] as Array<FormattedTreeItem | null>;

    for (const i in places.root) {
        rootItems.push(createTreeItem(places.root[i], 'root', [], items, (key: string) => places[key]));
    }

    const rootKeys = rootItems.filter((x) => x).map((x) => (x as FormattedTreeItem).key);

    items.root = {
        key: 'root',
        children: rootKeys,
    };

    return { items, rootKeys };
}